/**
 * Намерение подружиться, пережившее уход в Telegram.
 *
 * Человек нажимает «подружиться» один раз. Дальше он уходит входить, вкладка
 * может успеть заснуть или перезагрузиться — и просить его нажать то же самое
 * второй раз значит терять людей на ровном месте. Поэтому намерение
 * записывается до ухода и исполняется само, как только вход завершился.
 *
 * Хранилище вкладки: намерение живёт ровно столько, сколько сама вкладка, и не
 * достаётся ни другому человеку за тем же браузером, ни следующему визиту.
 */

const STORAGE_KEY = 'anon-chat.friend-intent';

export interface FriendIntent {
  /** Разговор, о котором шла речь: в другом это намерение уже не имеет смысла. */
  chatId: string;
  /** Есть — принять это предложение, нет — предложить дружбу самому. */
  requestId?: string;
}

export function rememberFriendIntent(intent: FriendIntent): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(intent));
  } catch {
    // Приватный режим: намерение просто не переживёт перезагрузку.
  }
}

export function readFriendIntent(): FriendIntent | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as FriendIntent) : null;
  } catch {
    return null;
  }
}

export function forgetFriendIntent(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // Нечего забывать.
  }
}
